import { IShoppingBagItem } from "../components/CheckoutComponents/ShoppingBag/ShoppingBagItem";

export const shoppingBagItems: IShoppingBagItem[] = [
  {
    id: "1",
    brandName: "Nike",
    productName: "React Infinity Run Flyknit 2",
    productLink: { href: "/" },
    productImage: { src: ".assets/images/1.jpg" },
    color: "White",
    prices: [
      {
        price: "20.55",
        currency: "€",
      },
      {
        price: "50.35",
        currency: "€",
        variant: "original",
      },
    ],
    size: "41",
    selectedQuantity: "1",
    availableQuantity: [
      { id: "1", title: "1" },
      { id: "2", title: "2" },
      { id: "3", title: "3" },
    ],
    isFavoriteAvailable: true,
  },
  {
    id: "2",
    brandName: "Nike",
    productName: "React Infinity Run Flyknit 2",
    productLink: { href: "/" },
    productImage: { src: ".assets/images/2.jpg" },
    color: "White",
    prices: [
      {
        price: "10.55",
        currency: "€",
      },
      {
        price: "53.35",
        currency: "€",
        variant: "original",
      },
    ],
    size: "41",
    selectedQuantity: "3",
    availableQuantity: [
      { id: "1", title: "1" },
      { id: "2", title: "2" },
      { id: "3", title: "3" },
    ],
    isFavoriteAvailable: true,
  },
  {
    id: "3",
    brandName: "Nike",
    productName: "React Infinity Run Flyknit 2",
    productLink: { href: "/" },
    productImage: { src: ".assets/images/3.jpg" },
    color: "White",
    prices: [
      {
        price: "20.55",
        currency: "€",
      },
      {
        price: "50.35",
        currency: "€",
        variant: "original",
      },
    ],
    size: "41",
    selectedQuantity: "1",
    availableQuantity: [
      { id: "1", title: "1" },
      { id: "2", title: "2" },
      { id: "3", title: "3" },
    ],
    isFavoriteAvailable: true,
  },
  {
    id: "4",
    brandName: "Nike",
    productName: "React Infinity Run Flyknit 2",
    productLink: { href: "/" },
    productImage: { src: ".assets/images/1.jpg" },
    color: "White",
    prices: [
      {
        price: "20.55",
        currency: "€",
      },
      {
        price: "50.35",
        currency: "€",
        variant: "original",
      },
    ],
    size: "41",
    selectedQuantity: "1",
    availableQuantity: [{ id: "1", title: "1" }],
  },
];

export const mockFootSizesOptions = ["39", "41", "42", "43"].map(
  (item, index) => ({
    id: String(index + 1),
    label: item,
  }),
);

export const mockColorOptions = [
  "black",
  "white",
  "red",
  "green",
  "gray",
  "red",
  "red",
].map((item, index) => ({
  id: String(index + 1),
  label: item,
}));
